













import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class BaseBackground extends Vue {
  /* --------------- Props --------------------- */
  @Prop() private image: string;
  @Prop() private innerClass: string;
  @Prop() private imageTop: boolean;
  @Prop() private imageBottom: boolean;
  @Prop() private imageFixed: boolean;

  /* --------------- Computed ------------------ */
  get classContainer() {
    return {
      'bg-image-top': this.imageTop,
      'bg-image-bottom': this.imageBottom,
      'bg-image-fixed': this.imageFixed,
    };
  }

  get classContainerInner() {
    return {
      [this.innerClass]: this.innerClass,
    };
  }
}
